import React, { useEffect, useState } from "react";

const TestimonialCard = ({ video, index }) => {
  const [loading, setLoading] = useState(true);

  const openVideo = () =>
    window.open(video.src.replace("autoplay=0", "autoplay=1"), "_blank");

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 300); // simulate loader
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="col-12 col-sm-6 col-lg-4">
      <div
        className={`yt-testimonial-card h-100 animate-in`}
        style={{ "--delay": `${index * 0.1}s`, position: "relative" }}
        onClick={openVideo}
      >
        {loading && (
          <div
            className="testimonial-loader-overlay d-flex justify-content-center align-items-center"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              zIndex: 10,
            }}
          >
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        <div className="yt-video-thumbnail">
          <img
            src={`https://img.youtube.com/vi/${
              video.src.split("/embed/")[1].split("?")[0]
            }/maxresdefault.jpg`}
            alt="testimonial"
            className="yt-card-thumbnail"
          />

          <div className="yt-play-overlay show">
            <div className="yt-play-button show">
              <i className="fa fa-play"></i>
            </div>
          </div>
        </div>
        <div className="yt-card-content">
          <h3 className="yt-card-title">{video.title}</h3>
          <div className="yt-channel-info">
            <div className="yt-channel-avatar">
              <i className="fa fa-user"></i>
            </div>
            <div className="yt-channel-details">
              <p className="yt-channel-name">{video.channel}</p>
              <div className="yt-video-stats">
                <i className="fa fa-clock-o"></i> {video.duration}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const MedEngageTestimonials = () => {
  const testimonialVideos = [
    {
      src: "https://www.youtube.com/embed/Km7Vze8y3fE?autoplay=0",
      title:
        "Metropolis Founder and Chairman, Dr. Sushil Shah shares his ideologies about MedEngage.",
      duration: "8:00",
      channel: "MedEngage",
    },
    {
      src: "https://www.youtube.com/embed/CZ_oKJMaY-I?autoplay=0",
      title: "Medical student Avanika on how MedEngage inspires her",
      duration: "1:29",
      channel: "MedEngage",
    },
    {
      src: "https://www.youtube.com/embed/OJfpyTRScl4?autoplay=0",
      title: "Medical student Apoorv on how MedEngage inspires him",
      duration: "1:18",
      channel: "MedEngage",
    },
    {
      src: "https://www.youtube.com/embed/q90JTYm_ipk?autoplay=0",
      title: "Medical Student Anusha on how MedEngage inspires her",
      duration: "2:28",
      channel: "MedEngage",
    },
    {
      src: "https://www.youtube.com/embed/R7Zae3nPlag?autoplay=0",
      title:
        "MedEngage Chief Guest Dr. Naresh Shetty shares his views on MedEngage",
      duration: "10:54",
      channel: "MedEngage",
    },
    {
      src: "https://www.youtube.com/embed/l1XyrPQfpXc?autoplay=0",
      title: "Medical student Suvansh on how MedEngage inspires him",
      duration: "1:57",
      channel: "MedEngage",
    },
    {
      src: "https://www.youtube.com/embed/fqpj0mylRHs?autoplay=0",
      title: "Medical student Madhava on how MedEngage inspires him",
      duration: "1:32",
      channel: "MedEngage",
    },
    {
      src: "https://www.youtube.com/embed/BQNCgyRfDwg?autoplay=0",
      title:
        "MedEngage Guest of Honor Padmashree Dr. T. P Lahane shares his views on the scholarship summit.",
      duration: "4:49",
      channel: "MedEngage",
    },
    {
      src: "https://www.youtube.com/embed/q8SLDVfwP8k?autoplay=0",
      title:
        "MedEngage jury member Dr. Gustad B Daver shares his views on the scholarship summit.",
      duration: "5:10",
      channel: "MedEngage",
    },
    {
      src: "https://www.youtube.com/embed/EAfrSHu9KYs?autoplay=0",
      title:
        "MedEngage jury member Dr. Amita Joshi shares his views on the scholarship summit.",
      duration: "1:40",
      channel: "MedEngage",
    },
    {
      src: "https://www.youtube.com/embed/iQQ80TSEQqk?autoplay=0",
      title:
        "MedEngage jury member Dr. Vijay Haribhakti shares his views on the scholarship summit.",
      duration: "9:21",
      channel: "MedEngage",
    },
  ];

  useEffect(() => {
    document.title = "Testimonials - MedEngage";
  }, []);
  const [loading, setLoading] = useState(true);

  // ✅ useEffect instead of React.useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 200); // loader disappears after 2s

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}
      <section className="yt-testimonial-section ul-section-spacing">
        <div className="container">
          <div className="yt-section-header"></div>
          <div className="row mb-3 g-4">
            {testimonialVideos.map((video, index) => (
              <TestimonialCard key={index} video={video} index={index} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default MedEngageTestimonials;
